export const totalBalanceColumn = [
  {
    key: "buyerName",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
  },
  {
    key: "previousDayBalance",
    label: "前日残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return typeof item.previousDayBalance === "number"
        ? new Intl.NumberFormat().format(item?.previousDayBalance.toFixed(0))
        : item.previousDayBalance;
    },
  },
  {
    key: "todaySaleExcludingTax",
    label: "本日税抜売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.todaySaleExcludingTax.toFixed(0))
        : null;
    },
  },
  {
    key: "todaySale",
    label: "本日売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.todaySale.toFixed(0))
        : null;
    },
  },
  {
    key: "cash",
    label: "本日入金高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.cash.toFixed(0))
        : null;
    },
  },
  {
    key: "todayBalance",
    label: "本日残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return typeof item.todayBalance === "number"
        ? new Intl.NumberFormat().format(item?.todayBalance.toFixed(0))
        : item.todayBalance;
    },
  },
];

export const totalBalanceMonthlyColumn = [
  {
    key: "buyerName",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
  },
  {
    key: "previousDayBalance",
    label: "前月残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return typeof item.previousDayBalance === "number"
        ? new Intl.NumberFormat().format(item?.previousDayBalance.toFixed(0))
        : item.previousDayBalance;
    },
  },
  {
    key: "todaySaleExcludingTax",
    label: "当月税抜売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.todaySaleExcludingTax.toFixed(0))
        : null;
    },
  },
  {
    key: "todaySale",
    label: "当月売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.todaySale.toFixed(0))
        : null;
    },
  },
  {
    key: "cash",
    label: "当月入金高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return item.buyerName !== "総計"
        ? new Intl.NumberFormat().format(item?.cash.toFixed(0))
        : null;
    },
  },
  {
    key: "todayBalance",
    label: "当月残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16.6%",
    },
    render: (item) => {
      return typeof item.todayBalance === "number"
        ? new Intl.NumberFormat().format(item?.todayBalance.toFixed(0))
        : item.todayBalance;
    },
  },
];

export const accountBalanceColumn = [
  {
    key: "buyerNo",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
    },
  },
  {
    key: "buyerName",
    label: "買人",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "26%",
    },
  },
  {
    key: "previousDayBalance",
    label: "前日残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "6%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(
        item?.previousDayBalance.toFixed(0)
      );
      
    },
  },
  {
    key: "todaySaleExcludingTax",
    label: "本日税抜売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(
        item?.todaySaleExcludingTax.toFixed(0)
      );
    },
  },
  {
    key: "todaySale",
    label: "本日売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.todaySale.toFixed(0));
    },
  },
  {
    key: "cash",
    label: "本日入金高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.cash.toFixed(0));
    },
  },
  {
    key: "todayBalance",
    label: "本日残高",
    align: "right", 
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.todayBalance.toFixed(0));
    },
  },
];

export const accountBalanceMonthlyColumn = [
  {
    key: "buyerNo",
    label: "",
    align: "left",
    cellProps: {
      minWidth: 20,
    },
  },
  {
    key: "buyerName",
    label: "買人",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "26%",
    },
  },
  {
    key: "previousDayBalance",
    label: "前月残高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "6%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(
        item?.previousDayBalance.toFixed(0)
      );
      
    },
  },
  {
    key: "todaySaleExcludingTax",
    label: "当月税抜売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(
        item?.todaySaleExcludingTax.toFixed(0)
      );
    },
  },
  {
    key: "todaySale",
    label: "当月売上高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.todaySale.toFixed(0));
    },
  },
  {
    key: "cash",
    label: "当月入金高",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.cash.toFixed(0));
    },
  },
  {
    key: "todayBalance",
    label: "当月残高",
    align: "right", 
    cellProps: {
      minWidth: 20,
      width: "16%",
    },
    render: (item) => {
      return new Intl.NumberFormat().format(item?.todayBalance.toFixed(0));
    },
  },
];